import formurlencoded from 'form-urlencoded';
import queryString from 'query-string';

export default function request(
  action,
  method,
  actionType = null,
  payload = {},
  fetchOptions = null
) {
  return function(dispatch) {
    if (actionType !== null) {
      dispatch({
        type: method.toUpperCase() + '_' + actionType + '_START',
        payload: payload
      });
    }

    let url = '';

    if (!Array.isArray(action)) {
      url = action;
    } else {
      url = REST_URL + action.join('/');
    }

    let options = fetchOptions || { credentials: 'include' };

    if (method === 'get') {
      options.method = 'get';
      url += '/' + queryString.stringify(payload).replace(/[\&\?=]/g, '/');
    } else {
      options.method = 'post';

      if (isFormData(payload)) {
        options.body = payload;
      } else {
        options.headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
        options.body = isFormData(payload) ? payload : formurlencoded(payload);
      }
    }

    return new Promise((resolve, reject) => {
      try {
        fetch(url, options)
        .then(
          (response) => {
            response.text().then((text) => {
              let json = null;
              try {
                json = text ? JSON.parse(text) : null;
              } catch (e) {
                json = { status: 'fail', message: text || response.statusText };
              }
              if (response.status === 200) {
                if (actionType !== null) {
                  dispatch({
                    type: method.toUpperCase() + '_' + actionType + '_COMPLETE',
                    payload: {
                      request: payload,
                      response: json
                    }
                  });
                }

                resolve(json);
              } else {
                if (actionType !== null) {
                  dispatch({
                    type: method.toUpperCase() + '_' + actionType + '_FAIL_PARSE',
                    payload: {
                      request: payload,
                      response: json
                    }
                  });
                }

                reject(json);
              }
            });
          },
          (response) => {
            if (actionType !== null) {
              dispatch({
                type: method.toUpperCase() + '_' + actionType + '_FAIL',
                payload: {
                  request: payload,
                  response: response
                }
              });
            }

            reject(response);
            return response;
          }
        ).catch((err) => {
          if (actionType !== null) {
            dispatch({
              type: method.toUpperCase() + '_' + actionType + '_FAIL',
              payload: {
                request: payload,
                response: err
              }
            });
          }
          reject(err);
        });
      } catch (exception) {
        if (actionType !== null) {
          dispatch({
            type: method.toUpperCase() + '_' + actionType + '_FAIL_REQUEST',
            payload: {
              request: payload,
              response: exception
            }
          });
        }

        reject(exception);
      }
    });
  }
};

function isFormData (object) {
  let isFormData = true;

  let formDataMethods = [
    'append',
    'delete',
    'get',
    'getAll',
    'has',
    'set'
  ];

  formDataMethods.forEach((item) => {
    isFormData = isFormData && (typeof object[item] === 'function');
  });

  return isFormData;
}
